// extracted by mini-css-extract-plugin
export default {"logo-container":"Logo_logo-container__xdIua","logo-image":"Logo_logo-image__H5xrW"};